import React from 'react';
import _ from 'lodash';
import { FormControl, TextField, Typography } from '@mui/material';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';
import { useDebouncedCallback } from 'use-debounce';

import { RequiredField } from '../others/RequiredField';
import { formatDateTime } from '../../services/functions';
import { InfoField } from './InfoField';

export const DateTimeField = props => {
  const { field, formik, getFieldCallback } = props;
  const debounced = useDebouncedCallback(
    val => {
      formik.setFieldValue(field.name, formatDateTime(val));
    },
    200
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <FormControl style={{ paddingBottom: 15 }} fullWidth>
        <Typography variant="subtitle1" style={{ paddingBottom: 15 }}>
          <b>{field.label}</b>
          <RequiredField required={field.required} isEmpty={_.isEmpty(formik.values[field.name])} formikError={formik.touched[field.name] && Boolean(formik.errors[field.name])} />
        </Typography>
        <DateTimePicker
          variant="standard"
          inputFormat="yyyy-MM-dd HH:mm"
          ampmInClock={false}
          ampm={false}
          mask="____-__-__ __:__"
          autoOk
          name={field.name}
          label={_.isEmpty(formik.values[field.name]) ? field.placeholder : null}
          value={formik.values[field.name]}
          onChange={val => debounced(val)}
          error={
            formik.touched[field.name] && Boolean(formik.errors[field.name])
          }
          helperText={formik.touched[field.name] && formik.errors[field.name]}
          renderInput={props => <TextField variant="standard" {...props} />}
          KeyboardButtonProps={{
            'aria-label': 'change date'
          }}
        />
        {
          !_.isEmpty(field.infos)
            ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
            : null
        }
      </FormControl>
    </LocalizationProvider>
  );
};
